import React, { useEffect } from "react";
import useStore from "../store";

import {
  useGetCredential,
  useGetViewer,
} from "../graphql/generated/definitions";
import { ViewerContext } from "../hooks/useViewer";

const ViewerProvider = ({ children }) => {
  const setViewer = useStore((state) => state.setViewer);
  const { loading, data } = useGetViewer();
  const { data: credentialData } = useGetCredential();
  const credential = credentialData?.credential;

  useEffect(() => setViewer(data?.viewer), [data]);

  return (
    <ViewerContext.Provider value={credential ? data?.viewer : null}>
      {loading ? null : children}
    </ViewerContext.Provider>
  );
};

export default ViewerProvider;
